
import NewsletterForm from '~/components/NewsletterForm.vue'
export default { 
  name: 'NewsletterSection',
  components: { NewsletterForm }
}
